import { Container } from '@chakra-ui/react'
import { Picture } from 'commons/components/header/Picture'
import { PageErrorCentered } from 'commons/components/layout/PageErrorCentered'
import PageLayout from 'commons/components/layout/PageLayout'
import { PageLoaderCentered } from 'commons/components/layout/PageLoaderCentered'
import { Spacing } from 'commons/design-system/tokens'
import useSuccessLydiaPageInfo from 'commons/hooks/services/useSucessLydiaPageInfo'
import SuccessPageContent from 'features/success-page/components/SuccessPageContent'
import { SuccessPageFooter } from 'features/success-page/components/SuccessPageFooter'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const LydiaPageSuccessPage = () => {
	const { t } = useTranslation()
	const identifier = useMemo(() => {
		const urlParams = new URLSearchParams(window.location.search)
		return urlParams.get('identifier') || ''
	}, [])
	const { data, isLoading, isError } = useSuccessLydiaPageInfo({ identifier })

	if (isLoading) {
		return <PageLoaderCentered />
	}

	if (isError) {
		return <PageErrorCentered message={t('success.error_fetching_data')} />
	}

	return (
		<PageLayout
			withConfetti
			alignItems='center'
			justifyContent='center'
			footer={<SuccessPageFooter />}
		>
			<Container
				maxW={'600px'}
				centerContent
				textAlign={'center'}
				px={Spacing.SM}
				mt={{ base: 10, md: 0 }}
			>
				<Picture
					image={
						data.collector_picture?.replace(
							/https:\/\/(\w+\.)?lydia-app\.com\//,
							`${process.env.REACT_APP_POTS_URL}collect/`
						) ?? `${process.env.REACT_APP_POTS_URL}collect/assets/img/default_user.png`
					}
					baseUrl={`${process.env.REACT_APP_POTS_URL}collect/`}
				/>
				<SuccessPageContent data={data} isMoneyPot={false} />
			</Container>
		</PageLayout>
	)
}

export default LydiaPageSuccessPage
